import React, { useRef } from "react";
import useReveal from "../../../hooks/useReveal"; // adjust path if needed
import "./Testimonial.css";


const testimonials = [
  {
    name: "Passive Income Anna",
    role: "ONLINE INCOME STRATEGIST",
    image: "https://res.cloudinary.com/dspelvbl1/image/upload/v1773091826/Anna_sog49h.png",
    text:
      "Thank you sooo much!! You really understood the assignment and delivered so swiftly. I’m genuinely impressed with your work and how smoothly everything went. You nailed every detail and made the whole process super easy. 🙏🏽🙏🏽🪄",
  },
  {
    name: "Chris Obike",
    role: "C.E.O, TENSAI KIDS TECH.",
    image: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091833/Chris_qmajfe.png",
    text:
      "Working with RemzyArts has been a major boost for Tensai Kids. His designs bring our vision to life, make our message clearer and more engaging, and consistently enhance how parents and learners connect with us. His creativity and professionalism truly elevate our brand.",
  },
  {
    name: "Fausat Abiola",
    role: "LEAD, P.M. EDUKIT",
    image: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091828/Fausat_a2a4ux.png",
    text:
      "Having RemzyArts on the Edukit web design team made a real difference. His creativity, clean design approach, and eye for user-friendly layouts helped us build a digital experience that truly represents our mission and connects better with our audience.",
  },
  {
    name: "Victory DM",
    role: "DIGITAL MARKETER",
    image: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091847/VictoryDM_mw5vgn.png",
    text:
      "RemzyArts has been a solid creative force behind my classes and ad campaigns. His designs are clean, captivating, and always on point. He brings ideas to life in a way that truly connects with the audience. Every time he delivers, I just say, Great work man!",
  },
  {
    name: "Drip by Meek",
    role: "FOUNDER DRIP BY MEEK",
    image: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091834/Drip-by-Meek_xudkpy.png",
    text:
      "RemzyArts has been incredible in shaping my brand’s visuals. His flyer designs are stylish, attention-grabbing, and perfectly capture the vibe of Drip by Meek. His creativity and attention to detail make every design stand out and truly elevate the brand’s presence.",
  },
  {
    name: "Meek XRP",
    role: "FOUNDER MEEK XRP",
    image: "https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091843/MeekXRP-profile_hsr6bw.png",
    text:
      "RemzyArts has done an amazing job creating the graphics for Meek XRP. His designs are clean, professional, and engaging, making our brand look trustworthy and appealing. His creativity consistently elevates our visual identity.",
  },
];

const Testimonial = () => {

  const trackRef = useRef(null);
  const textRevealRef = useReveal();
  const carouselRevealRef = useReveal();



  return (
    <section className="testimonial-wrapper">
      <div className="testimonial-blur-shape" aria-hidden="true" />

      <div
          className="testimonial-text reveal"
          ref={textRevealRef}
        >
        <h5>TESTIMONIAL</h5>
        <h2>What Clients Say</h2>
      </div>

        <div
          className="testimonial-carousel reveal"
          ref={carouselRevealRef}
        >

        <div className="testimonial-track" ref={trackRef}>
          {[...testimonials, ...testimonials].map((item, index) => (
            <div className="testimonial-card" key={index}>
              <p className="testimonial-text-body">{item.text}</p>

              <div className="testimonial-footer">
                <div className="testimonial-user">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="testimonial-avatar"
                  />
                  <div>
                    <h4>{item.name}</h4>
                    <span>{item.role}</span>
                  </div>
                </div>

                <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091832/Quote_tasznq.svg" alt="" className="quote-icon" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
